<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="41"
		height="40"
		viewBox="0 0 41 40"
		fill="none"
	>
		<path
			d="M32.3485 32.9067L8.70764 32.9067C7.74604 32.9067 6.93607 32.2125 6.77946 31.2549L4.41637 16.7342C4.29168 15.9661 4.62684 15.193 5.27223 14.7661C5.93258 14.3282 6.78345 14.3342 7.43881 14.781L12.8114 18.4479L18.8473 8.14962C19.1974 7.55211 19.8418 7.18204 20.5291 7.18204C21.2164 7.18204 21.8608 7.55311 22.2099 8.14962L28.2458 18.4479L33.6184 14.781C34.2727 14.3342 35.1236 14.3282 35.7849 14.7661C36.4293 15.193 36.7655 15.9661 36.6408 16.7342L34.2767 31.2559C34.1211 32.2125 33.3101 32.9077 32.3495 32.9077L32.3485 32.9067ZM9.0847 30.5127L31.9715 30.5127L34.1161 17.3396L28.5361 21.1481C28.2618 21.3357 27.9226 21.4005 27.5994 21.3277C27.2752 21.2549 26.9969 21.0514 26.8293 20.7651L20.5291 10.016L14.2288 20.7651C14.0613 21.0514 13.782 21.2549 13.4588 21.3277C13.1346 21.4005 12.7954 21.3357 12.5221 21.1481L6.94205 17.3396L9.08669 30.5127H9.0847Z"
			fill="white"
		/>
	</svg>
</template>
